import { LlmProvider, Model } from '../Types';
import requestClient from '../components/Utility/RequestClient';
import Store from '../Store/Store';

const resolveDemo = () => Store.getState().environment.demoInstance;

export const modelService = {
    saveModel: async (type: string, data: any): Promise<any> => {
        return requestClient.post<Model>(`/model/${type}`, data);
    },

    getModelsByPage: (
        page: number,
        itemsPerPage: number,
        additionalParams?: Record<string, any>,
        query?: string | null,
    ): Promise<{ data: { data: Model[]; total: number } }> => {
        return requestClient
            .get(`${resolveDemo() ? 'demo' : ''}/model/get`, {
                params: {
                    page,
                    itemsPerPage,
                    query,
                },
            })
            .then((response: any) => response);
    },

    getModels: async (): Promise<{ data: Model[] }> => {
        return requestClient.get<Model[]>(`${resolveDemo() ? 'demo' : ''}/model/get`);
    },

    getModel: async (modelIdentifier: string): Promise<{ data: Model }> => {
        return requestClient.get<Model>(`${resolveDemo() ? 'demo' : ''}/model/get/${modelIdentifier}`);
    },

    getLlmProviders: async (): Promise<{ data: any }> => {
        return requestClient.get<LlmProvider[]>(`/model/getllmproviders`);
    },

    deleteModel: async (identifier: string): Promise<any> => {
        return requestClient.delete(`/model/delete/${identifier}`);
    },
};
